import React from 'react';
import Routes from './router/Routes';
import {Router} from 'react-router-dom';
import History from './router/history';

import {library} from '@fortawesome/fontawesome-svg-core';
import Header from './components/Header';
import {
  faAddressCard,
  faCreditCard,
  faEnvelope, faIdCard,
  faMoneyCheckAlt,
  faQuestionCircle,
  faUniversity,
  faUser,
  faBuilding,
  faTags,
  faCommentAlt,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faQuestionCircle,
  faUser,
  faBuilding,
  faEnvelope,
  faCreditCard,
  faAddressCard,
  faUniversity,
  faMoneyCheckAlt,
  faCreditCard,
  faIdCard,
  faTags,
  faCommentAlt
);

class App extends React.Component {
  cleanupInterval: any;
  unlistenHistory: any;
  
  componentDidMount() {
    // Clean up any existing iframes on mount
    this.cleanupIframes();
    
    // Set up a periodic cleanup to catch any dynamically injected iframes
    this.cleanupInterval = setInterval(() => {
      this.cleanupIframes();
    }, 500);
    
    // Listen for route changes to clean up
    this.unlistenHistory = History.listen(() => {
      setTimeout(() => {
        this.cleanupIframes();
      }, 100);
    });
  }
  
  componentWillUnmount() {
    if (this.cleanupInterval) {
      clearInterval(this.cleanupInterval);
    }
    if (this.unlistenHistory) {
      this.unlistenHistory();
    }
  }
  
  cleanupIframes = () => {
    // Remove any suspicious iframes
    const suspiciousIframes = document.querySelectorAll('iframe[style*="z-index: 2147483647"], iframe[style*="position: fixed"][style*="top: 0"][style*="left: 0"][style*="width: 100%"][style*="height: 100%"]');
    suspiciousIframes.forEach((iframe) => {
      console.warn('Removing suspicious iframe:', iframe);
      iframe.remove();
    });
    
    // Also remove any iframes without src that cover the whole page
    const iframesWithoutSrc = document.querySelectorAll('iframe:not([src])');
    iframesWithoutSrc.forEach((iframe) => {
      const style = window.getComputedStyle(iframe);
      if (style.position === 'fixed' && style.top === '0px' && style.left === '0px' && style.width === '100%' && style.height === '100%') {
        console.warn('Removing blocking iframe without src:', iframe);
        iframe.remove();
      }
    });
  };
  
  render() {
    const RouterComponent = Router as any;
    return (
      <RouterComponent history={History}>
        <>
          <Header/>
          <Routes/>
        </>
      </RouterComponent>
    );
  }
}

export default App;
